import useCreate from "@/hooks/use-create";
import { UseLoadingReturn } from "@/hooks/use-loading";
import { IContactInput } from "@/interfaces/contact.interface";
import contactService from "@/services/contact.service";
import { RequestsProps } from "@/types/requests.types";

export type CreateContactProps = {
  formData: IContactInput;
} & RequestsProps;

export type UseCreateContactReturn = {
  create: (props: CreateContactProps) => Promise<void>;
} & UseLoadingReturn;

const useCreateContact = (): UseCreateContactReturn => {
  const { isLoading, startLoading, endLoading, loadingIcon, create } = useCreate<IContactInput>({
    operation: (formData) => contactService.create(formData),
  });

  return {
    isLoading,
    startLoading,
    endLoading,
    loadingIcon,
    create,
  };
};

export default useCreateContact;
